import { render, staticRenderFns } from "./d-discover-feed-search.vue?vue&type=template&id=130b7c30&"
import script from "./d-discover-feed-search.vue?vue&type=script&lang=js&"
export * from "./d-discover-feed-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports